import BaseDTO from '../base/BaseDTO';

export default class CountryLanguage extends BaseDTO {

    public countryId: number
    public languageId: number;

    constructor(data: { [key: string]: any }) {
        super(data);
        this.countryId = data['countryId'];
        this.languageId = data['languageId'];
    }
}